import styled from 'styled-components';

import List, { ListItem } from 'calcite-react/List';

const StyledList = styled(List)`
    background-color: '#ffffff';
    width: '70px';
`;

const StyledListItem = styled(ListItem)`
    font-family: 'Open Sans';
    font-weight: '600';
    margin-left: '.1rem !important';
    margin-right: '.8rem !important';
    padding: '7.5px 8px';
    line-height: '24.5px';
    size: '14px';
`;

export { StyledList, StyledListItem };
